import { useEffect, useState } from "react";
import Loading from "../components/Loading/Loading";
import {
  makeStyles,
  Grid,
  TextField,
  Button,
  MenuItem,
  Typography
} from "@material-ui/core";
import CustomButton from "../components/common/controls/CustomButton";
import DMGrid from "../components/common/controls/Grid/DMGrid";
import DMModal from "../components/common/controls/DMModal";
import DMDeleteDialog from "../components/common/controls/DMDeleteDialog";
import * as miscAction from "../actions/miscAction";
import * as modelAction from "../actions/modelAction";
import * as discountAction from "../actions/discountAction";
import * as discountsOfferedAction from "../actions/discountsOfferedAction";
import { connect } from "react-redux";
import "./pageStyles.scss";
import { deleteDiscountsOfferedService } from "../services/DiscountsOfferedService";
import { DELETE_SERVICE_ERROR_MESSAGE } from "../utilities/applicationutils"; 
var CONTROLS_DATA = require("./ControlsData.json");
var MODELS_CONTROLS = CONTROLS_DATA.SCREENS.MODELS;

const DiscountsOffered = ({
  discountState,
  getDiscounts,
  getDiscountsOffered,
  getDiscountsOfferedListData,
  createDiscountsOffered,
  updateDiscountsOffered,
  deleteDiscount,
  renderDiscountsListData,
  getTransactionTypes,
  TransactionTypeState,
  updateState,
  modelState,
  deleteModel,
  setSnackBar,
  discountOfferedState
}) => {
  const [discountData, setDiscountData] = useState([]);
  const [discountOfferedId, setDiscountOfferedId] = useState("");
  const [discountId, setDiscountId] = useState("");
  const [discountLabel, setDiscountLabel] = useState("");
  const [discountPercentage, setDiscountPercentage] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [transactionTypeId, setTransactionTypeId] = useState("");
  const [showNewModel, setShowNewModel] = useState(false);
  const [showEditModel, setShowEditModel] = useState(false);
  const [loading, setLoading] = useState(false);
  const [gridData, setGridData] = useState([]);
  const [showDelete, setShowDelete] = useState(false);
  const [sortBy, setSortBy] = useState("");
  const newDiscountOnClick = () => { 
    setDiscountLabel(""); 
    setDiscountPercentage(""); 
    setTransactionType(""); 
    setShowNewModel(true);
  }
  const retriveSalesOfficeId = localStorage.getItem("salesOfficeValue");
  const handleChange = (value) => {
    setSortBy(value);
  };

  const handleDiscount = async () => {
    if(transactionType && discountPercentage.trim()){
    try {
      const payload = {
        discountId: transactionType,
        Criteria: discountPercentage.trim(),
        salesOfficeId: retriveSalesOfficeId
      };
      await createDiscountsOffered(payload);
      await getDiscountsOffered(retriveSalesOfficeId);
      const discountName = discountState && discountState.find((discounts) => discounts.discountId === transactionType).discountLabel;
      setSnackBar(true, "success", `Created new discount: ${discountName}`);
      setLoading(false);
      setShowNewModel(false);
    } catch (error) {
      setShowNewModel(false);
      setSnackBar(
        true,
        "error",
        `Error while creating a new discount offered ${discountLabel}`
      );
    }
    }
    else {
      setSnackBar(true, "error", `Please select Discount and criteria!`);
      setLoading(false);
    }
  };

  const onEdit = (dId, cName, cSymbol, transactionText) => {
    setShowEditModel(true);
    setDiscountOfferedId(dId);
    setDiscountId(cName);
    const discountFindId = discountState.find((discounts) => discounts.discountLabel === cSymbol);
    setTransactionType(discountFindId.discountId);
    setDiscountPercentage(transactionText);
  };

  const handleEditDiscount = async () => {
    if(discountPercentage.trim()){
    try {
      const payload = {
        discountOfferedId: discountOfferedId,
        discountId: transactionType,
        Criteria: discountPercentage.trim(),
        salesOfficeId: retriveSalesOfficeId
      };
      await updateDiscountsOffered(discountOfferedId, payload);
      await getDiscountsOffered(retriveSalesOfficeId);
      const discountName = discountState && discountState.find((discounts) => discounts.discountId === transactionType).discountLabel;
      setSnackBar(true, "success", `Discount updated: ${discountName}`);
      setLoading(false);
      setShowEditModel(false);
    } catch (error) {
      setShowEditModel(false);
      setSnackBar(true, "error", `Error while updating a new update`);
    }
  } 
  else {
      setSnackBar(true, "error", `Please enter criteria.`);
      setLoading(false);
  }
  };

  const onDelete = (dId, dLabel) => {
    setDiscountOfferedId(dId);
    setDiscountLabel(dLabel);
    setShowDelete(true);
  };

  const deleteConfirm = async (discountLabel) => {
    try {
      setLoading(true);
      const payload = {
        discountOfferedId: discountOfferedId,
      };
      await deleteDiscountsOfferedService(payload.discountOfferedId).then( async (response) => {
      await getDiscountsOffered(retriveSalesOfficeId);
      setSnackBar(true, "success", `${discountLabel} has been deleted.`);
      setLoading(false);
      setShowDelete(false);
    })
    .catch((error) =>{
      setSnackBar(true,"error", error?.response?.data?.errorMessage || DELETE_SERVICE_ERROR_MESSAGE);
      setLoading(false);
      setShowDelete(false);
    })
    } catch (error) {
      setSnackBar(
        true,
        "error",
        `Error while deleting discount ${discountLabel}`
      );
      setLoading(false);
    }
  };

  const useStyles = makeStyles((theme) => ({
    paper: {
      position: "absolute",
      width: 400,
      backgroundColor: theme.palette.background.paper,
      padding: theme.spacing(2, 4, 3),
      maxHeight: "75%",
    },
    gridHeaderColumns: {
      display: "grid",
      width: "100%",
      gridTemplateColumns: "25% 10% 15% 45% 5%",
      color: "#617080",
      fontSize: "14px",
      fontFamily: "Arial",
      fontWeight: "500",
    },
  }));

  function getModalStyle() {
    const top = 50;
    const left = 50;

    return {
      top: `${top}%`,
      left: `${left}%`,
      transform: `translate(-${top}%, -${left}%)`,
    };
  }
  const classes = useStyles();

  const [modalStyle] = useState(getModalStyle);

  const updatePropertyName = (inputArray, oldPropertyName, newPropertyName) => {
    const updatedArray = inputArray?.map((obj) => {
      const { [oldPropertyName]: propertyValue, ...rest } = obj;
      return {
        [newPropertyName]: propertyValue,
        ...rest,
      };
    });
    return updatedArray;
  };

  const handleSelectDiscount = (e) => {
    const selectedId = e.target.value;
    const isOffered = discountOfferedState && discountOfferedState.some(discount => discount.discountId === selectedId);
    if (isOffered) {
      setTransactionType("");
      setSnackBar(true,"error","This discount is not allowed as it is already offered.");
      setLoading(false);
      return false;
    }
    setTransactionType(selectedId);
    return true;
  };

  useEffect(() => {
    const fetchDiscount = async () => {
      try {
        await Promise.all([getDiscountsOffered(retriveSalesOfficeId),getDiscounts(), getTransactionTypes()]);
      } catch (error) {
        console.log("get discounts fails", error);
      }
    };
    fetchDiscount();
  }, [getDiscountsOffered, getDiscounts, getTransactionTypes]);

  useEffect(() => {
    if(discountOfferedState.length>0 && discountState.length>0 && TransactionTypeState.length>0){
      const filteredDiscountOffered = discountOfferedState.map(discountOffered => {
        const discount = discountState.find(d => d.discountId === discountOffered.discountId);
        const transactionType = TransactionTypeState.find(t => t.transactionTypeId === discount.transactionTypeId);
        
        return {
            discountOfferedId: discountOffered.discountOfferedId,
            discountId: discount.discountId,
            discountLabel: discount.discountLabel,
            discountPercentage: discount.discountPercentage + "%",
            transactionTypeText: transactionType.transactionTypeText,
            criteria: discountOffered.criteria
        };
    }).filter(item => item.discountId !== undefined);
    
      getDiscountsOfferedListData(filteredDiscountOffered);
    }
    else{
      getDiscountsOfferedListData([]);
    }
  }, [discountOfferedState, discountState, TransactionTypeState]);

  useEffect(() => {
    const ctrlData = [];
    renderDiscountsListData.length>0 && renderDiscountsListData.forEach((model) => {
      ctrlData.push({
        rowKey: model.discountId,
        discountOfferedId: model.discountOfferedId,
        discountLabel: model.discountLabel,
        discountPercentage: model.discountPercentage,
        transactionTypeText: model.transactionTypeText,
        criteria: model.criteria || "NA",
        rowValue: [
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: model.discountLabel,
              tab: "discounts",
              model: model,
              //onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: model.discountPercentage,
              tab: "discounts",
              model: model,
              //onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: model.transactionTypeText,
              tab: "discounts",
              model: model,
              //onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-label",
            colOptions: {
              width: "100px",
              value: model.criteria,
              tab: "discounts",
              model: model,
              //onUpdate: onUpdateModelName,
            },
          },
          {
            colType: "grid-actions",
            colOptions: [
              {
                name: "edit",
                tab: "discounts",
                action: () =>
                  onEdit(
                    model.discountOfferedId,
                    model.discountId,
                    model.discountLabel,
                    model.criteria
                  ),
                width: "100px",
              },
              {
                name: "delete",
                action: () => onDelete(model.discountOfferedId, model.discountLabel),
              },
            ],
          },
        ],
      });
    });
    setGridData(ctrlData);
  }, [renderDiscountsListData, sortBy]);

  return (
    <div container className="page-container content-center">
      <Loading open={loading} />
      <Grid container xs={12} md={11} className="page-content">
        <Grid item container xs={12} md={12} justify="flex-end">
          <CustomButton
            id="newModel"
            showGradient={true}
            variant="contained"
            color="primary"
            disabled={false}
            name="Add Discounts Offered"
            onClick={newDiscountOnClick}
          />
        </Grid>
        {gridData?.length == 0 &&      
          <Grid item container xs={12} md={11}>
            <Typography className="filter-label" gutterBottom sx={{paddingLeft:10}}>No Records Found.</Typography>
          </Grid>
          }
        <Grid item container xs={12} md={12}>
          {gridData?.length > 0 && (
            <DMGrid
              key={Math.random()}
              headers={MODELS_CONTROLS.DISCOUNT_OFFERED_HEADER}
              headerClassName={classes.gridHeaderColumns}
              data={gridData}
              loading={loading}
              // selectedPage={modelState.selectedPage}
              // onPageSelection={onSelectedPage}
              setGridData={(t) => {
                setGridData(t);
              }}
            />
          )}
        </Grid>
        <DMModal open={showNewModel} onClose={() => setShowNewModel(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">New Discount Offered</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
              <TextField
                id=""
                select
                labelId="region-name-select-required-label"
                label={"Select Discount*"}
                variant="outlined"
                value={transactionType}
                onChange={handleSelectDiscount}
                placeholder="Select Discount"
              >
                {discountState && discountState.map((discounts) => {
                  return (
                    <MenuItem key={discounts.discountId} value={discounts.discountId}>
                      {discounts.discountLabel}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                id="outlined-basic-userEmail"
                label="Criteria*"
                variant="outlined"
                type="text"
                autoComplete="off"
                value={discountPercentage}
                onChange={(e) => setDiscountPercentage(e.target.value)}
              />
              <Grid item xs={12} container style={{ justifyContent: "center" }}>
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setShowNewModel(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleDiscount}
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </DMModal>
        <DMModal open={showEditModel} onClose={() => setShowEditModel(false)}>
          <div style={modalStyle} className={classes.paper}>
            <h3 id="simple-modal-title">Edit Discount Offered</h3>
            <div style={{ display: "flex", flexDirection: "column", gap: 10 }}>
            <TextField
                disabled
                id=""
                select
                labelId="region-name-select-required-label"
                label="Select Discount"
                variant="outlined"
                value={transactionType}
                onChange={handleSelectDiscount}
                placeholder="Select Discount"
              >
                {discountState && discountState.map((discounts) => {
                  return (
                    <MenuItem value={discounts.discountId}>
                      {discounts.discountLabel}
                    </MenuItem>
                  );
                })}
              </TextField>
              <TextField
                id="outlined-basic-userEmail"
                label="Criteria*"
                variant="outlined"
                type="text"
                autoComplete="off"
                value={discountPercentage}
                onChange={(e) => setDiscountPercentage(e.target.value)}
              />
              <Grid item xs={12} container style={{ justifyContent: "center" }}>
                <Grid item xs={6}>
                  <Button
                    variant="outlined"
                    onClick={() => {
                      setShowEditModel(false);
                    }}
                  >
                    Cancel
                  </Button>
                </Grid>
                <Grid item xs={6}>
                  <Button
                    color="primary"
                    variant="contained"
                    onClick={handleEditDiscount}
                    className="makeStyles-gradient-27"
                  >
                    OK
                  </Button>
                </Grid>
              </Grid>
            </div>
          </div>
        </DMModal>
        <DMDeleteDialog
          open={showDelete}
          onClose={() => setShowDelete(false)}
          // title={"Are you sure to delete?"}
          contentText={`${discountLabel} will be deleted.`}
          discardText={"Cancel"}
          agreeText={"OK"}
          onProceed={() => {
            deleteConfirm(discountLabel);
          }}
        />
      </Grid>
    </div>
  );
};
const mapStateToProps = (state) => ({
  discountState: state.discount.discounts.data,
  discountOfferedState: state.discountList.discountsOfferList.data || [],
  renderDiscountsListData: state.discountList.renderDiscountsOfferedListData || [],
  TransactionTypeState: state.discount.transactionTypes.data,
  updateState: state.discount.updateDiscount.data,
  modelState: state.model,
});

const mapDispatchToProps = (dispatch) => {
  return {
    getDiscounts: async () => dispatch(discountAction.getDiscounts()),
    getTransactionTypes: async () => dispatch(discountAction.getTransactionTypes()),
    getDiscountsOffered: async (retriveSalesOfficeId) => dispatch(discountsOfferedAction.getDiscountsOffered(retriveSalesOfficeId)),
    getDiscountsOfferedListData: async (renderDiscountsListData) =>
      dispatch(discountsOfferedAction.getDiscountsOfferedListData(renderDiscountsListData)),
    createDiscountsOffered: async (requestPayload) =>
      dispatch(discountsOfferedAction.createDiscountsOffered(requestPayload)),
    updateDiscountsOffered: async (discountOfferedId,requestPayload) =>
      dispatch(discountsOfferedAction.updateDiscountsOffered(discountOfferedId,requestPayload)),
    deleteDiscount: async (requestPayload) =>
      dispatch(discountAction.deleteDiscount(requestPayload)),
    onTabSelected: (tabId) => dispatch(miscAction.onTabSelected(tabId)),
    setSnackBar: (show, severity, message) =>
      dispatch(miscAction.setSnackBar(show, severity, message)),
    onCloseSelected: (data) => dispatch(miscAction.onCloseSelected(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(DiscountsOffered);
